import { APICall } from ".";

export const ax_form_warrantyForm = async (paylaod) => {
  try {
    const res = await APICall.post(`/form`, paylaod, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log("res - " + JSON.stringify(res.data));

    if (
      res.data.code === 200 ||
      res.data.code === 201 ||
      res.data.code === 409
    ) {
      return res.data;
    } else if (!res.data.success) {
      return res.data;
    }
    return null;
  } catch (e) {
    // console.log("Error in warrantyForm: " + e);
    console.log("e.response.data:", e.response ? e.response.data : e.message);
    console.log("e.message:", e.response ? e.response.data : e.message);
    if (
      e.response?.data.code !== 200 ||
      e.response?.data.code !== 201 ||
      e.response?.data.code !== 409
    )
      return e.response;
    else return null;
  }
};

export const ax_claim_claimFetch = async (paylaod) => {
  try {
    console.log("ax paylaod - " + JSON.stringify(paylaod));
    const res = await APICall.post(`/claim/claimFetch`, paylaod);
    console.log("res - " + JSON.stringify(res.data));

    if (res.data.code === 200 || res.data.code === 201) {
      return res.data;
    } else if (!res.data.success) {
      return res.data;
    }
    return null;
  } catch (e) {
    // console.log("Error in warrantyForm: " + e);
    console.log("e.response.data:", e.response ? e.response.data : e.message);
    console.log("e.message:", e.response ? e.response.data : e.message);
    if (e.response?.data.code !== 200 || e.response?.data.code !== 201)
      return e.response;
    else return null;
  }
};

export const ax_claim_createIssue = async (paylaod, warrantyFormID) => {
  try {
    console.log("ax paylaod - " + JSON.stringify(paylaod));
    const res = await APICall.post(
      `/claim/createIssue/${warrantyFormID}`,
      paylaod,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    console.log("res - " + JSON.stringify(res.data));

    if (
      res.data.code === 200 ||
      res.data.code === 201 ||
      res.data.code === 409
    ) {
      return res.data;
    } else if (!res.data.success) {
      return res.data;
    }
    return null;
  } catch (e) {
    // console.log("Error in warrantyForm: " + e);
    console.log("e.response.data:", e.response ? e.response.data : e.message);
    console.log("e.message:", e.response ? e.response.data : e.message);
    if (
      e.response?.data.code !== 200 ||
      e.response?.data.code !== 201 ||
      e.response?.data.code !== 409
    )
      return e.response;
    else return null;
  }
};

export const ax_claim_claimCreatedIssue = async (warrantyFormID) => {
  try {
    console.log("ax warrantyFormID - " + JSON.stringify(warrantyFormID));
    const res = await APICall.get(
      `/claim/getAllClaimIssuesByWarrantyFormID/${warrantyFormID}`
    );
    console.log("res - " + JSON.stringify(res.data));

    if (res.data.code === 200 || res.data.code === 201) {
      return res.data;
    } else if (!res.data.success) {
      return res.data;
    }
    return null;
  } catch (e) {
    // console.log("Error in warrantyForm: " + e);
    console.log("e.response.data:", e.response ? e.response.data : e.message);
    console.log("e.message:", e.response ? e.response.data : e.message);
    if (e.response?.data.code !== 200 || e.response?.data.code !== 201)
      return e.response;
    else return null;
  }
};

export const ax_form_verifyWowNo = async (serialNo) => {
  try {
    const baseURL = "https://tii.in/tici_warrantyclaim/api/warrantyclaim/get";
    const url = `${baseURL}?SerialNo=${encodeURIComponent(serialNo)}`;

    console.log("ax payload - " + JSON.stringify(serialNo));

    const res = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    // Check if the response is successful (status 200-299)
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }

    const data = await res.json();
    console.log("res - ", res);
    console.log("data - ", data);

    // Check for success codes in the response
    if ([200, 201, 409].includes(data.code)) {
      return data;
    } else if (!data.success) {
      return data;
    }

    return null;
  } catch (e) {
    // Log error details
    console.log("Error:", e.message || e);
    if (e.response && e.response.data) {
      console.log("Error response data:", e.response.data);
    }
    return null;
  }
};

export const ax_warranty_generatePresignedURL = async (warrantyFormID) => {
  try {
    console.log("ax warrantyFormID - " + JSON.stringify(warrantyFormID));
    const res = await APICall.get(
      `/claim/getAllClaimIssuesByWarrantyFormID/${warrantyFormID}`
    );
    console.log("res - " + JSON.stringify(res.data));

    if (res.data.code === 200 || res.data.code === 201) {
      return res.data;
    } else if (!res.data.success) {
      return res.data;
    }
    return null;
  } catch (e) {
    // console.log("Error in warrantyForm: " + e);
    console.log("e.response.data:", e.response ? e.response.data : e.message);
    console.log("e.message:", e.response ? e.response.data : e.message);
    if (e.response?.data.code !== 200 || e.response?.data.code !== 201)
      return e.response;
    else return null;
  }
};

// import { APICall } from ".";

// export const ax_form_warrantyForm = async (paylaod) => {
//   try {
//     const res = await APICall.post(`/form`, paylaod, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });
//     console.log("Response:", JSON.stringify(res.data));

//     if ([200, 201].includes(res.data.code)) {
//       return res.data;
//     }
//     return res.data;
//   } catch (e) {
//     console.error(
//       "Error in warrantyForm:",
//       e.response ? e.response.data : e.message
//     );
//     if (![200, 201].includes(e.response?.data.code)) {
//       return e.response?.data;
//     }
//     return null;
//   }
// };
